'use client';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { CatIconInfo } from 'blocks-nextjs/blocks-react/components/Icons/Info';
import { BUTTON_VARIANTS } from '@cat-ecom/pcc-components/src/constants/commonConstants';
import { CatInlineNotification } from 'blocks-nextjs/blocks-react/components/InlineNotification';
import { SignInButton } from '../../../_header/components/sign-in-button';
import { MYEQUIPMENT_GUEST_BANNER } from 'components/my-equipment/constants';

type GuestLoginBannerProps = {
  registerButton: JSX.Element;
};

const GuestLoginBanner = ({
  registerButton
}: Readonly<GuestLoginBannerProps>) => {
  const t = useTranslations();
  const [isVisibleBanner, setIsVisibleBanner] = useState(false);

  useEffect(() => {
    const lastClosedTime = localStorage.getItem('modalClosedTime');
    if (lastClosedTime) {
      const now = new Date().getTime();
      const closedTime = parseInt(lastClosedTime, 10);
      if (now - closedTime > 24 * 60 * 60 * 1000) {
        setIsVisibleBanner(true);
      }
    } else {
      setIsVisibleBanner(true);
    }
  }, []);
  // session storage
  const handleDismissBanner = () => {
    setIsVisibleBanner(false);
    localStorage.setItem('modalClosedTime', new Date().getTime().toString());
  };

  return (
    isVisibleBanner && (
      <div className="mb-5 mt-3" id={MYEQUIPMENT_GUEST_BANNER}>
        <CatInlineNotification
          className="mb-2 d-block"
          dismissible
          heading={t('MEQ_GUEST_MESSAGING_TITLE')}
          data-testid="guest-user-message"
          onBlInlineNotificationClose={() => handleDismissBanner()}
        >
          <CatIconInfo slot="before" />

          <span className="pb-3 pb-sm-0 d-block">
            {t('DESCRIPTION_CREATE_AN_ACCOUNT')}
          </span>
          <div slot="after">
            {registerButton}
            <SignInButton fullWidth={false} variant={BUTTON_VARIANTS.GHOST} />
          </div>
        </CatInlineNotification>
      </div>
    )
  );
};

export default GuestLoginBanner;
